import { useQuery } from '@tanstack/react-query'
import { graviGet } from './request'
import type { GraviTaskDoc } from './types'

export type { GraviTaskDoc } from './types'

/**
 * Polls a task's status while a reply is pending (no live stream attached) so
 * the UI can distinguish "still working" from failed / cancelled / stalled.
 * Ported from S&D `api/gravi/useTaskStatus.ts`.
 *
 * TODO(genapi): swap to `$api.useQuery('get', '/gravitutor/tasks/{task_id}')`
 * once the path is in the generated OpenAPI types.
 */
export function useGraviTaskStatus(
  taskId: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ['gravitutor', 'tasks', taskId ?? ''],
    queryFn: ({ signal }) =>
      graviGet<GraviTaskDoc>(`/gravitutor/tasks/${taskId}`, signal),
    enabled: enabled && Boolean(taskId),
    refetchInterval: 4000,
    retry: false,
  })
}
